import { render, staticRenderFns } from "./form-brand.vue?vue&type=template&id=be2e4a2c&scoped=true"
import script from "./form-brand.vue?vue&type=script&lang=js"
export * from "./form-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2e4a2c",
  null
  
)

export default component.exports